// MetricDetailsTable.tsx
import React, { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ReusableTable from '../../../../../../components/TableComponent';
import { MasterConfigs } from '../../../../../../interfaces/entity';

interface MetricDetailsTableProps {
  title: string;
}

const MetricDetailsTable: React.FC<MetricDetailsTableProps> = ({ title }) => {
  const [search, setSearch] = useState('');

  const tableConfig: MasterConfigs = {
    api: () => `/api/metrics/${title.toLowerCase().replace(/\s+/g, '-')}`,
    loadPagination: true,
    queryParams: { search },
    renderComponent: () => (
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-base font-semibold text-gray-800">{title} List</h3>
        <Input
          size="middle"
          placeholder="Search"
          prefix={<SearchOutlined className="text-gray-400" />}
          className="w-64 rounded-md border-gray-300"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    ),
    getColumns: () => [
      { title: 'Lead Name', dataIndex: 'leadName', render: (text: string) => <span className="text-gray-600">{text || 'Sarah Lee'}</span> },
      { title: 'Account Name', dataIndex: 'accountName', render: (text: string) => <span className="text-gray-600">{text || 'Brain Games Studio'}</span> },
      { title: 'Assigned BDE', dataIndex: 'bde', render: (text: string) => <span className="text-gray-600">{text || 'Sarah Lee'}</span> },
      { title: 'Created at', dataIndex: 'createdAt', render: (text: string) => <span className="text-gray-600">{text || '13 Oct 2025 10:11'}</span> },
      { title: 'Stage', dataIndex: 'stage', render: (text: string) => <span className="text-blue-500 font-medium">{text || 'Won'}</span> },
      { title: 'Source', dataIndex: 'source', render: (text: string) => <span className="text-gray-600">{text || 'LinkedIn'}</span> },
    ],
    tableProps: {
      bordered: false,
      size: 'middle',
      scroll: { x: 'max-content' },
      pagination: { size: 'small', showSizeChanger: false, className: 'mt-6' }
    },
  };

  return (
    <div className="rounded-md">
      <ReusableTable config={tableConfig} />
    </div>
  );
};

export default MetricDetailsTable;